export default __webpack_public_path__ + "static/media/rightArrow.6cff5bfa.svg";